@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.checkbox {
  margin-right:  hevo-toolkit-variables.$spacer * 0.5 !important;
}

.text {
  display: flex;
  flex-direction: column;
  cursor: pointer;

  label {
    cursor: pointer;
  }
}
